import './VulnerabilitySubTabs.scss';

// The nested tab strip of the Vulnerabilities tab. Same look as the Threat > Events tab bar
// (pages/events/ActionTypeBar): text tabs, the active one coloured and underlined. `labels` maps each tab
// to its text; the defaults are the K8s Vulnerabilities sub tabs.

const LABELS = { findings: 'By Findings', cves: 'By CVEs', workloads: 'By Workloads', images: 'By Images' };

const VulnerabilitySubTabs = ({ tabs, selectedTab, onChange, labels = LABELS }) => (
  <div className="VulnerabilitySubTabs" role="tablist" aria-label="Vulnerabilities views">
    {tabs.map(tab => {
      const isActive = tab === selectedTab;
      return (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`VulnerabilitySubTabs__Tab${isActive ? ' VulnerabilitySubTabs__Tab--active' : ''}`}
          onClick={() => !isActive && onChange(tab)}>
          {labels[tab] ?? tab}
        </button>
      );
    })}
  </div>
);

export default VulnerabilitySubTabs;
